import styled from '@emotion/styled';
import React, { useState } from 'react';
import Checkbox, { CheckboxProps } from 'semantic-ui-react/dist/commonjs/modules/Checkbox';
import { css } from '@emotion/react';
import tw from 'twin.macro';

interface Props {
  label?: string | JSX.Element | null;
  labelLeft?: boolean;
  checked?: boolean;
  onChange?: (e: boolean) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>, data: CheckboxProps) => void;
  className?: string;
  labelClassName?: string;
  show?: boolean;
  value?: boolean;
  disabled?: boolean;
  classContainer?: string;
  isConfirm?: boolean;
}

const ToggleOnOff = styled(
  ({
    label,
    labelLeft,
    value,
    labelClassName,
    onClick,
    onChange,
    checked,
    classContainer,
    isConfirm,
    show,
    ...props
  }: Props) => {
    const [isChecked, setIsChecked] = useState(show ?? checked ?? false);

    React.useEffect(() => {
      setIsChecked(show ?? checked ?? value ?? false);

      // We maintain the value of checked in the toggle switch until reset
      // changes so that visually we can show the toggle turning on or off
      // even in cases where we error out and need to switch it back

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, checked, value]);

    return (
      <div
        className={`${classContainer} flex flex-row items-center`}
        css={css`
          .ui.toggle.checkbox input ~ .box:after,
          .ui.toggle.checkbox input ~ label:after {
            left: 0;
          }
        `}
      >
        <Checkbox
          onClick={onClick}
          css={[
            show !== undefined
              ? css`
                  @keyframes progress {
                    0% {
                      opacity: 0.75;
                    }
                    50% {
                      opacity: 0.05;
                    }
                    100% {
                      opacity: 0.75;
                    }
                  }
                  > input {
                    ~ label {
                      &::before {
                        animation: progress 2s infinite;
                      }
                    }
                  }
                `
              : '',
            labelLeft
              ? css`
                  > input {
                    ~ label {
                      padding-left: 0 !important;
                      padding-right: 3.5rem !important;
                      &::before {
                        right: -0rem;
                        left: auto !important;
                        transition: all 0.1s ease !important;
                      }
                      &::after {
                        right: 1.05rem;
                        left: auto !important;
                        transition: all 0.1s ease !important;
                      }
                    }
                    &:checked {
                      ~ label {
                        &::after {
                          right: -0.05rem;
                        }
                      }
                    }
                  }
                `
              : '',
          ]}
          toggle
          {...{ ...props, type: 'checkbox' }}
          checked={isChecked === true}
          onChange={(): void => {
            if (isConfirm) {
              onChange && onChange(!isChecked);
              return;
            }
            onChange && onChange(!isChecked);
            setIsChecked(!isChecked);
          }}
          label={
            <label
              className={`duration-500 transition-color inline-flex ${labelClassName}`}
              css={css`
                ${tw`flex items-center text-lg font-normal text-color-input-field`}
                > span {
                  display: inline-flex;
                }
              `}
            >
              {label}
            </label>
          }
          disabled={props.disabled}
        />
      </div>
    );
  }
)``;

export default ToggleOnOff;
